import React, { useState, useEffect } from "react";
import Loading from "../Modals/Loading";
import purchaseService from "../Services/purchaseService";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { LuEye } from "react-icons/lu";
import Head from "../Components/Head";

const PurchaseOrder = () => {
  const [loading, setLoading] = useState(false);
  const [purchases, setPurchases] = useState([]);
  const [order, setOrder] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const getPurchase = async () => {
      try {
        setLoading(true);
        const response = await purchaseService.fetchAll();
        setPurchases(response.purchases);
        console.log("purchases", response.purchases);
        setLoading(false);
      } catch {}
    };
    getPurchase();
  }, []);
  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <div className="">
          <Loading />
        </div>
      ) : (
        <div>
          <div className=" flex flex-col">
            {/* <Head
              heading={"Purchase Orders"}
              button_text={"Add Order"}
              navigation={() => navigate("/purchase/add")}
            /> */}
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold text-secondary">
                Purchase Order
              </h1>
              <div className="flex gap-3">
                <button
                  onClick={() => navigate("/purchase/addorder")}
                  className="button-primary"
                >
                  Add Order
                </button>
                <button
                  className="button-primary bg-sky-600"
                  onClick={() => navigate("/purchase/view/addpickingmanual")}
                >
                  Start Picking
                </button>
              </div>
            </div>
            <div className="table-div">
              <table>
                <thead>
                  <tr className="border-y-2 text-left w-full text-black text-[10px]">
                    <th className="rounded-tl-lg py-4 w-[1%] pl-4">ID</th>
                    <th className="py-4 w-[1%]">Purchase Date</th>
                    <th className="py-4 w-[1.5%]">Supplier</th>
                    <th className="py-4 w-[2%]">Ref No.</th>
                    <th className="py-4 w-[1%]">Payment Status</th>
                    <th className="py-4 w-[1%]">Purchase Status</th>
                    <th className="py-4 w-[1%] text-center">Amount</th>
                    <th className="rounded-tr-lg py-4 w-[1%] text-center">
                      View
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {purchases?.map((value, index) => (
                    <tr
                      key={index}
                      className="bg-accent border-b border-gray-100 text-left"
                    >
                      <td className="py-4 w-[1%] text-blue-500 font-bold pl-4">
                        {value.id}
                      </td>
                      <td className="py-4 w-[1%]">
                        {moment(value.purchase_date).format("ll")}
                      </td>
                      <td className="py-4 w-[1.5%] pr-4 text-xs font-semibold">
                        {value.company}
                      </td>
                      <td className="py-4 w-[2%] pr-4">{value.reference}</td>
                      <td className={`py-4 w-[1%]`}>
                        <div
                          className={`py-1 w-fit px-2 rounded-md uppercase font-semibold ${
                            value.payment_status === "PAID"
                              ? "bg-green-500 text-green-500 bg-opacity-20"
                              : "bg-red-500 text-red-500 bg-opacity-20"
                          }`}
                        >
                          {value.payment_status}
                        </div>
                      </td>
                      <td className="py-4 w-[1%]">
                        <div
                          className={`py-1 w-fit px-2 rounded-md uppercase font-semibold ${
                            value.status === "Invoice"
                              ? "bg-indigo-500 text-indigo-500 bg-opacity-20"
                              : "bg-amber-500 text-amber-500 bg-opacity-20"
                          }`}
                        >
                          {value.status}
                        </div>
                      </td>
                      <td className="py-4 w-[1%] font-semibold text-center">
                        {value.amount}
                      </td>
                      <td className="py-4 w-[1%] text-center">
                        <button
                          className="text-blue-500"
                          onClick={() =>
                            navigate(`/purchase/view?id=${value.id}`)
                          }
                        >
                          <LuEye className="h-4 w-4" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default PurchaseOrder;
